const feed = [
    {
        profile: "AJ + Español",
        profileUrl: "https://i.imgur.com/QJruc0xm.png",
        username: "ajplusespanol",
        content: `Laika fue elegida para viajar al espacio sabiendo que no resistiría.
        ¿Son éticas nuestras maneras de hacer ciencia? 
        Queremos saber qué opinas.
        `,
        interaction: {
            comments: 5,
            retweets: 66,
            likes: 126
        },
        verified: false,
        blocked: false
    },
    {
        profile: "Elon Musk",
        profileUrl: "https://i.imgur.com/rNMKJSQl.jpg",
        username: "elonmusk",
        content: `Several thousand more Starlink beta participation invitations going out this week.
        `,
        interaction: {
            comments: 6700,
            retweets: 3700,
            likes: 84000
        },
        verified: true,
        blocked: false
    },
    {
        profile: "Google",
        profileUrl: "https://i.imgur.com/xosRXkNl.jpg",
        username: "google",
        content: `20 years ago today the first crew of astronauts and researchers arrived at the International Space Station, forever changing how we explore space. Cohete Celebrate #SpaceStation20th with @NASA
        & @GoogleArts by exploring a 3D model of the`,
        interaction: {
            comments: 26,
            retweets: 100,
            likes: 693
        },
        verified: true,
        blocked: false
    },
    {
        profile: "LeBron James",
        profileUrl: "https://i.imgur.com/d7KVNXwl.jpg",
        username: "KingJames",
        content: `Y’all see the setup right???!!!`,
        interaction: {
            comments: 17600,
            retweets: 1300,
            likes: 78800
        },
        verified: true,
        blocked: false
    },
    {
        profile: "BBC Breaking News",
        profileUrl: "https://i.imgur.com/YbqahGPl.jpg",
        username: "BBCBreaking",
        content: `Prince William contracted Covid-19 in April at a similar time to his father Prince Charles, palace sources tell BBC
        `,
        interaction: {
            comments: 1300,
            retweets: 2200,
            likes: 4200
        },
        verified: true,
        blocked: false
    },
    {
        profile: "NVIDIA GeForce",
        profileUrl: "https://i.imgur.com/Agv0nC3l.jpg",
        username: "NVIDIAGeForce",
        content: `Hitch a ride on the RTX Battle Bus!
        Experience Fortnite in a new light with NVIDIA ray traced shadows, global illumination and ambient occlusion. 
        Learn more about RTX, DLSS, and NVIDIA Reflex in Fortnite: https://nvidia.com/en-us/geforce/campaigns/play-fortnite-with-rtx/`,
        interaction: {
            comments: 56,
            retweets: 34,
            likes: 524
        },
        verified: true,
        blocked: false
    },
    {
        profile: "National Geographic",
        profileUrl: "https://i.imgur.com/3nwHKzRl.jpg",
        username: "NatGeo",
        content: `What's the most soothing experience you've had in nature? (Bonus points if you have a photo or video)`,
        interaction: {
            comments: 128,
            retweets: 76,
            likes: 434
        },
        verified: true,
        blocked: false
    },
    {
        profile: "Hipertextual",
        profileUrl: "https://i.imgur.com/w8FdS5Pl.jpg",
        username: "Hipertextual",
        content: `Cinco recomendaciones, y una sorpresa, para ver en Netflix en noviembre`,
        interaction: {
            comments: 0,
            retweets: 1,
            likes: 4
        },
        verified: true,
        blocked: false
    },
    {
        profile: "Hipertextual",
        profileUrl: "https://i.imgur.com/w8FdS5Pl.jpg",
        username: "Hipertextual",
        content: `Cinco recomendaciones, y una sorpresa, para ver en Netflix en noviembre`,
        interaction: {
            comments: 0,
            retweets: 1,
            likes: 4
        },
        verified: true,
        blocked: false
    },{
        profile: "Real Madrid C.F.",
        profileUrl: "https://i.imgur.com/6kZ2yA5l.jpg",
        username: "realmadrid",
        content: `¡El capitán, @SergioRamos, alcanza la cifra de 1️⃣0️⃣0️⃣ goles con la camiseta del 
        @RealMadrid! #RealFootball | #HalaMadrid`,
        interaction: {
            comments: 210,
            retweets: 3700,
            likes: 14900
        },
        verified: true,
        blocked: false
    },
    {
        profile: "UEFA Champions League",
        profileUrl: "https://i.imgur.com/rs0iJu3l.jpg",
        username: "ChampionsLeague",
        content: `Bayern have won their last 13 Champions League games... #UCL`,
        interaction: {
            comments: 19,
            retweets: 54,
            likes: 818
        },
        verified: true,
        blocked: false
    },
    {
        profile: "FC Barcelona",
        profileUrl: "https://i.imgur.com/9IlaO4rl.jpg",
        username: "FCBarcelona_es",
        content: `¡La 
        @LigadeCampeones no se detiene!
        Preparados para una nueva noche europea. 
        Este miércoles, #BarçaDynamo`,
        interaction: {
            comments: 6,
            retweets: 30,
            likes: 723
        },
        verified: true,
        blocked: true
    },
    {
        profile: "Youtube",
        profileUrl: "https://i.imgur.com/jCaFJzUl.jpg",
        username: "Youtube",
        content: `Drop links to the videos that are helping you right now`,
        interaction: {
            comments: 4900,
            retweets: 878,
            likes: 11300
        },
        verified: true,
        blocked: true
    }
];

export {
    feed
}